import TrackerSDK from '@ns-track/core'
import { useAuthStore } from '@/store'
import router from '@/router'

const track = new TrackerSDK({
  serverUrl: import.meta.env.VITE_APP_API_TRACK, // 必须：数据上报地址
  appId: 'jmsmx-station-web', // 必须：应用标识
  appName: '墨西哥驿站站点端', // 必须：应用标识
  batchSize: 10,
  batchDelay: 500
})

export function pvTrack(to: any, from: any) {
  try {
    setTimeout(() => {
      const authStore = useAuthStore()
      track.pvTrack({
        routeName: to.name,
        referrer: from.name,
        pageTitle: to.meta.title || document.title,
        userId: authStore?.userInfo?.userCode,
        userName: authStore?.userInfo?.name
      })
    })
  } catch (error) {
    console.log('error', error)
  }
}

export function eventTrack(eventCode: string, eventName: string) {
  try {
    setTimeout(() => {
      const authStore = useAuthStore()
      const route = router.currentRoute
      track.track(eventCode, eventName, {
        routeName: route.name,
        pageTitle: route.meta.title || document.title,
        userId: authStore?.userInfo?.userCode,
        userName: authStore?.userInfo?.name
      })
    })
  } catch (error) {
    console.log('error', error)
  }
}
